import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { notification } from 'antd';
import orderService from 'api/order.service';
import customerService from 'api/customer.service';
import { get, isEmpty } from 'lodash';
import { displayAppLoading } from 'reducers/app/app.reducer';
import { RootState } from 'reducers/root';
import { getMessage } from 'utils';

interface ISetState {
  dataList?: Order[];
  isLoading?: boolean;
}

interface IQueryError {
  message: string;
}

export interface OrderState {
  dataList?: any;
  headerCount?: any;
  isLoading: boolean;
  errors?: string[];
  customers: any;
  total: number;
}

const initialState: OrderState = {
  isLoading: false,
  errors: null,
  dataList: [],
  customers: [],
  total: 0,
};

const slice = createSlice({
  name: 'orders',
  initialState: initialState,
  reducers: {
    setState(state: OrderState, { payload }: PayloadAction<ISetState>) {
      state.isLoading = payload.isLoading;
      if (payload.dataList) {
        state.dataList = payload.dataList;
      }
    },
    onFetchOrdersSuccess(
      state: OrderState,
      { payload }: PayloadAction<Order[]>
    ) {
      state.dataList = payload;
    },
    updateHeaderCount(state: OrderState, { payload }: PayloadAction<any>) {
      state.headerCount = payload;
    },
    onFetchCustomersSuccess(
      state: OrderState,
      { payload }: PayloadAction<Order[]>
    ) {
      state.customers = payload;
    },
    updateFetchPaginationTotal(
      state: OrderState,
      { payload }: { payload: number }
    ) {
      state.total = payload;
    },
  },
});

export const {
  setState,
  onFetchOrdersSuccess,
  onFetchCustomersSuccess,
  updateFetchPaginationTotal,
  updateHeaderCount,
} = slice.actions;

export default slice.reducer;

export const fetchData = (inParams) => async (dispatch, getState) => {
  try {
    const appState: RootState = getState();
    const params = { ...inParams };
    if (appState.app.loading === true || isEmpty(params))
      return Promise.resolve();
    dispatch(displayAppLoading(true));
    if (params.page_size) {
      params.page_size = Number(params.page_size);
    }
    if (!params.search_text) {
      delete params.search_text;
    }
    if (!params.type || params.type == 0) {
      delete params.type;
    }
    if (!params.fin_status || params.fin_status === '') {
      delete params.fin_status;
    }
    // const response = await orderService.getOrderList(params);
    const response = await orderService.getOrderListV2(params);
    const transformedResponseData = get(response.data, 'data', []);
    const d2 = get(response.data, 'header_count', []);
    dispatch(updateHeaderCount(d2));
    const total = get(response.data, 'total', 0);
    if (transformedResponseData.length > 0) {
      dispatch(updateFetchPaginationTotal(total as number));
      dispatch(onFetchOrdersSuccess(transformedResponseData));
    } else {
      dispatch(onFetchOrdersSuccess([]));
    }
  } finally {
    dispatch(displayAppLoading(false));
  }
};

export const fetchCustomers = (params) => async (dispatch) => {
  try {
    const response = await customerService.findParams(params);
    const transformedResponseData = get(response, 'data', []);
    if (transformedResponseData.length > 0) {
      dispatch(onFetchCustomersSuccess(transformedResponseData));
    }
  } catch (err) {
    console.error('Error', err);
  } finally {
    dispatch(displayAppLoading(false));
  }
};
